module.exports = __webpack_public_path__ + "img/roku.65450053.svg";